var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.druckVorlagen.length)?_c('extra-druck-vorlagen-render',{attrs:{"value":_vm.druckVorlagen[0],"item":_vm.text,"bg":3,"color":"white","no-editor":"","border":false}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }